var _path, _ellipse, _path2, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96541 3.95573L8.49903 4.67071L9.03348 3.95635C9.58691 3.21662 10.4729 2.73698 11.4597 2.73698C13.135 2.73698 14.4997 4.10205 14.4997 5.79698C14.4997 6.51781 14.3848 7.18198 14.1854 7.79843L14.184 7.80277C13.7051 9.31838 12.7194 10.5515 11.6393 11.4797C10.5563 12.4105 9.41688 13.0013 8.69827 13.2458L8.69825 13.2458L8.69113 13.2483C8.67134 13.2553 8.60201 13.2703 8.49967 13.2703C8.39734 13.2703 8.32801 13.2553 8.30822 13.2483L8.30824 13.2483L8.30108 13.2458C7.58247 13.0013 6.44301 12.4105 5.36004 11.4797C4.28 10.5515 3.29429 9.31838 2.81536 7.80277L2.81537 7.80277L2.81397 7.79843C2.61453 7.18198 2.49967 6.51781 2.49967 5.79698C2.49967 4.10219 3.86408 2.7372 5.53926 2.73698C6.01048 2.73764 6.47506 2.84809 6.89615 3.05959C7.31737 3.27115 7.68347 3.57798 7.96541 3.95573Z",
    fill: "url(#paint0_linear_5481_95324)",
    stroke: "url(#paint1_linear_5481_95324)",
    strokeWidth: 1.33333
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.44814,
    cy: 3.51989,
    rx: 1.74717,
    ry: 0.589131,
    transform: "rotate(24.8956 6.44814 3.51989)",
    fill: "url(#paint2_linear_5481_95324)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3532 4C0.853516 6.5 4.353 11.5 7.35276 12.5",
    stroke: "url(#paint3_linear_5481_95324)",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.69551,
    cy: 0.589131,
    rx: 1.69551,
    ry: 0.589131,
    transform: "matrix(-0.907076 0.420966 0.420966 0.907076 12.1406 2.29688)",
    fill: "url(#paint4_linear_5481_95324)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5481_95324",
    x1: 8.49967,
    y1: 2.07031,
    x2: 8.49967,
    y2: 13.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186786,
    stopColor: "#E44B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD2846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E33659"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5481_95324",
    x1: 8.49967,
    y1: 2.07031,
    x2: 8.49967,
    y2: 13.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD2846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E33659"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5481_95324",
    x1: 6.44814,
    y1: 2.93076,
    x2: 6.44814,
    y2: 4.10902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5481_95324",
    x1: 1.85352,
    y1: 4,
    x2: 5.85352,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0340756,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537851,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5481_95324",
    x1: 1.69551,
    y1: 0,
    x2: 1.69551,
    y2: 1.17826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.7481d2616a30c2860d63301f5ef81c39.svg";
export { ForwardRef as ReactComponent };